/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name inputpayrate
 * @description special input used on Staff Clocks page for Full Payroll users.
 */
angular.module('mercury.directives.inputpayrate', [])
.directive('inputpayrate', ["$filter", "dialog", function($filter, dialog) {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'directives/inputpayrate/inputpayrate.tpl.html',
    link: function(scope, element, attrs) {
      scope.renderAsLink = !!attrs.inputpayrateRenderAsLink;

      var templateUrl = 'directives/inputpayrate/inputpayratedialog.tpl.html';

      // If readonly attribute is thruthy then change to readonly template
      if (!!attrs.inputpayrateReadOnly) {
        templateUrl = 'directives/inputpayrate/viewpayratedialog.tpl.html';
      }

      scope.selectedRole = null;
      scope.selectedRule = 'normal';

      scope.updateRole = function() {
        scope.activeStaffRole = $filter('filter')(scope.staffMember.memberRoles, {roleId: scope.selectedRole})[0];
      };

      /**
       * 'Save' button callback. Apply local Role and Rate changes to the scope clock.
       */
      scope.save = function() {
        scope.adjustedHourlyRate = scope.getAdjustedRate(scope.clock);
        // Call the onSave callback function
        scope.$eval(attrs.onSave);
      };

      scope.showPayRateDialog = function() {
        var staffMember = $filter('filter')(scope.staff, {id: scope.clock.staffMemberId})[0];
        var staffMemberRoles;
        if (scope.staffMember) {
          staffMemberRoles = angular.copy(scope.staffMember.memberRoles);
        } else {
          // If the staff member was deleted.
          staffMemberRoles = [
            {roleId: scope.clock.roleId, roleName: scope.clock.roleName, hourlyRate: scope.clock.hourlyRate}
          ];
        }

        dialog.open({
          backdrop: 'static',
          templateUrl: templateUrl,
          controller: 'InputPayrateModalCtrl',
          size: 'xl',
          resolve: {
            dialogData: function() {
              return {
                staffMember: angular.copy(staffMember),
                clock: angular.copy(scope.clock),
                activeStaffRole: angular.copy($filter('filter')(staffMemberRoles, {roleId: scope.clock.roleId})[0]),
                activePackages: angular.copy(scope.activePackages)
              };
            }
          }
        }).then(function(dialogResults) {
          if (dialogResults && dialogResults.newClock) {
            scope.clock = dialogResults.newClock;
            scope.hourlyRateUpdated();
          }
        });
      };

      /**
       * Callback for when the hourly rate is edited directly. re-sync the directive model
       * then call the onSave callback
       */
      scope.hourlyRateUpdated = function() {
        scope.$eval(attrs.onSave);
      };
    }
  };
}]);
